'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var cms = require('../../../decorators/cms.js');
var enums = require('../../cms/enums.js');
var classes = require('../../cms/classes.js');

class CtaLinkToggle extends classes.BaseComponentCMSFields {
    constructor() {
        super(...arguments);
        this.isEnabled = false;
    }
}
tslib_es6.__decorate([
    cms.CMSField('Enabled', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], CtaLinkToggle.prototype, "isEnabled", void 0);
tslib_es6.__decorate([
    cms.CMSField('Display Text', enums.CMSFieldTypes.Text),
    tslib_es6.__metadata("design:type", Object)
], CtaLinkToggle.prototype, "displayText", void 0);
tslib_es6.__decorate([
    cms.CMSField('Destination', enums.CMSFieldTypes.Text),
    tslib_es6.__metadata("design:type", Object)
], CtaLinkToggle.prototype, "destination", void 0);

exports.CtaLinkToggle = CtaLinkToggle;
//# sourceMappingURL=base.js.map
